<template>
  <woot-modal
    :show="show"
    :on-close="onClose"
    :size="sizeClass"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </woot-modal>
</template>

<script>
export default {
  name: 'ModalV2',
  inheritAttrs: false,
  props: {
    show: { type: Boolean, default: false },
    onClose: { type: Function, required: true },
    size: {
      type: String,
      default: 'md',
      validator: value => ['md', 'sm'].includes(value),
    },
    relaxedHeader: { type: Boolean, default: false },
  },
  computed: {
    sizeClass() {
      const base = `modal-v2 modal-v2--${this.size}`;
      return this.relaxedHeader ? `${base} modal-v2--relaxed-header` : base;
    },
  },
};
</script>
